module.exports = __webpack_public_path__ + "img/image-style-11.8e7d1fdf.svg";